module.exports = __webpack_public_path__ + "static/media/amazon-uk-icon.6b0e9519.svg";